<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="rules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">{{ appTitle }}</h3>
      </div>
      <el-form-item prop="email">
        <span class="svg-container">
          <i class="el-icon-user" />
        </span>
        <el-input
          v-model="loginForm.email"
          placeholder="Địa chỉ Email"
          :disabled="loading"
          type="text"
          tabindex="1"
        />
      </el-form-item>

      <el-tooltip
        v-model="capsTooltip"
        content="Đang bật CAPS LOCK"
        placement="right"
        manual
      >
        <el-form-item prop="password">
          <span class="svg-container">
            <i class="el-icon-lock" />
          </span>
          <el-input
            v-model="loginForm.password"
            type="password"
            show-password
            placeholder="Mật khẩu"
            :disabled="loading"
            tabindex="2"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
      </el-tooltip>
      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%; margin-bottom: 30px"
        @click.native.prevent="handleLogin"
      >
        Đăng nhập
      </el-button>
    </el-form>
  </div>
</template>

<script>
import constants from "@/config/constants";
import authServices from "@/services/auth";
import profileServices from "@/services/profile";
import organizationServices from "@/services/organization";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      rules: {
        email: [{ required: true, message: "Email không được để trống" }],
        password: [{ required: true, message: "Mật khẩu không được để trống" }],
      },
      loading: false,
      capsTooltip: false,
      appTitle: constants.APP_TITLE,
    };
  },
  methods: {
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          authServices
            .login(this.loginForm)
            .then(async (response) => {
              console.log("Login response:", response);
              authServices.updateLoginInfo(response);
              const profiles = await profileServices.list();
              const organizations = Object.keys(profiles.organizations).map((key) => ({
                ...profiles.organizations[key]
              }))
              if (organizations.length > 0) {
                profileServices.setProfiles({
                  is_super_admin: profiles.is_super_admin,
                  organizations,
                })
                organizationServices.setCurrentOrg(organizations[0])
                this.$notify({
                  title: "Thành công",
                  message: "Đăng nhập thành công",
                  type: "success",
                });
                // window.location.reload();
              } else {
                authServices.logout();
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message.error(
                "Địa chỉ Email hoặc mật khẩu không chính xác."
              );
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}
/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>
<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100vh;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-form {
    position: relative;
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
